import type { HTMLAttributes, ReactElement } from 'react';
import styles from '../popup.module.css';

export function PopupBadge({ children, ...props }: HTMLAttributes<HTMLDivElement>): ReactElement {
  return (
    <div className={styles.badge} {...props}>
      {children}
    </div>
  );
}
